import * as React from 'react';
import {
    Toolbar,
    Box,
    TextField
} from "@mui/material";
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AlterSectionsEdit from '../../Components/AlterSections/AlterDialogs/AlterSectionsEdit';
import AlterSectionsAdd from '../../Components/AlterSections/AlterDialogs/AlterSectionsAdd';
import FilterInput from '../StyledInputs/StyledTextInput';
import { alterBoxSx } from '../../Utils/styles/sxStyles';
import { filterSelectionSx } from '../../Utils/constants';
import { FORM_FIELD_ENTITYID, FORM_FIELD_NAME } from '../../Utils/constants/formFieldCodes';
import { TITLE_SINGULAR_ORGANIZATION } from '../../Utils/constants/titleCodes';
import { createSelectionList } from '../../Utils/helpers/listCreation';

const getDefaultForm = () => {
    return {
        format: {
            entityId: "Id",
            name: "Name",
        },
        entity: {
            entityId: "",
            name: "",
        },
        errors: {
            entityId: false,
            name: false,
        }
    }
}

const OrganizationAlter = (props) => {

    const [entityIds, setEntityIds] = useState([]);

    useEffect(() => {
        createSelectionList(props.rows, FORM_FIELD_ENTITYID, setEntityIds);
    }, [props.rows]);

    const addInputs = (entityForm, handleFormChange) => {
        return (
            <Box>
                <TextField
                    error={entityForm.errors.name}
                    data-testid="textInput"
                    helperText={entityForm.errors.name ? "Please fill in a name" : null}
                    sx={filterSelectionSx}
                    onChange={(event) => handleFormChange(event.target.value, FORM_FIELD_NAME)}
                    label="Organization Name"
                    variant="outlined"
                />
            </Box>
        )
    }

    const editInputs = (entityForm, selectEntity, isDisabled, handleFormChange) => {
        return (
            <Box>
                <FilterInput
                    sx={{ m: 1, width: "80%" }}
                    label={"IDs"}
                    setSelection={selectEntity}
                    optionList={entityIds}
                    multiSelect={false}
                    isError={entityForm.errors.entityId}
                />
                <TextField
                    sx={filterSelectionSx}
                    error={entityForm.errors.name}
                    helperText={entityForm.errors.name ? "Please fill in a name" : null}
                    label={"Name"}
                    value={entityForm.entity.name}
                    onChange={(event) => handleFormChange(event.target.value, FORM_FIELD_NAME)}
                    disabled={isDisabled}
                />
            </Box>
        )
    }

    return (
        <Box sx={alterBoxSx}>
            <Toolbar>
                <AlterSectionsAdd
                    entityName={TITLE_SINGULAR_ORGANIZATION}
                    alterInputs={addInputs}
                    defaultForm={getDefaultForm}
                />
                <AlterSectionsEdit
                    rows={props.rows}
                    entityName={TITLE_SINGULAR_ORGANIZATION}
                    alterInputs={editInputs}
                    defaultForm={getDefaultForm}
                />
            </Toolbar>
        </Box>
    )
}

OrganizationAlter.propTypes = {
    rows: PropTypes.array.isRequired,
};



export default OrganizationAlter;